import { useTranslation } from 'react-i18next'
import { DetailsList } from '@/components/DetailsList/DetailsList'
import { Text } from 'ui/src/components/Text/Text'
import { sprinkles } from 'ui/src/theme/sprinkles.css'
import { type useOfferDetails } from '../useOfferDetails'

type Props = {
  details: ReturnType<typeof useOfferDetails>
}

export function ProductDetails({ details }: Props) {
  const { t } = useTranslation('cart')

  return (
    <div>
      <Text size={{ _: 'sm', sm: 'md' }} className={sprinkles({ mb: 'xxs' })}>
        {t('VIEW_ENTRY_DETAILS_BUTTON')}
      </Text>

      <DetailsList.Root size={{ _: 'sm', sm: 'md' }} gap={{ _: 'none', sm: 'xxs' }}>
        {details.map(({ title, value }) => (
          <DetailsList.Item key={title}>
            <DetailsList.Label>{title}</DetailsList.Label>
            <DetailsList.Value>{value}</DetailsList.Value>
          </DetailsList.Item>
        ))}
      </DetailsList.Root>
    </div>
  )
}
